import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import blog from "../../../../assets/blog.jpg";
import blog1 from "../../../../assets/rsto/IMG_1327.jpg"
import blog2 from "../../../../assets/rsto/d-two/IMG_1220.jpg"
import blog3 from "../../../../assets/rsto/d-two/IMG_1216.jpg"
import "./Blogs.css"
import { NavLink } from "react-router-dom";

const Blogs = () => {
    return (
        <div className="blog-content">

            <Row className="gx-0">
                <Col md={6} className='p-0'><img data-aos="zoom-in"
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="2000" className="w-100" src={blog2} alt="" /></Col>
                <Col md={6} className="d-flex justify-content-center align-items-center p-0">
                    <div data-aos="zoom-in"
                        data-aos-easing="ease-out-cubic"
                        data-aos-duration="2000" className="text-center blog">
                        <div className="my-3 my-md-0">
                            <h1 className="blog-h1">PATIO EN PLEIN AIR</h1>
                            {/* <h1 className="section-header text-uppercase my-4" style={{ borderBottom: '5px solid goldenrod', fontSize: '4rem'}}>Open air patio</h1> */}
                        </div>
                        <div className="mt-3 px-2 mt-md-3 px-md-5">
                            <p>Venez nous rejoindre sur notre terrasse à ciel ouvert cet été.</p>
                            <p>Profitez d'une expérience de niveau Michelin sous les étoiles dans notre nouvelle tranche de patio.</p>
                        </div>
                        <NavLink to="/contact">
                            <button className="animated-button victoria px-4 px-md-5">Confirmer La Réservation</button>
                        </NavLink>
                    </div>
                </Col>
                <Col md={6} className='p-0 d-md-none'><img data-aos="zoom-in"
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="2000" className="w-100" src={blog1} alt="" /></Col>
                <Col md={6} className="d-flex justify-content-center align-items-center p-0">
                    <div data-aos="zoom-in"
                        data-aos-easing="ease-out-cubic"
                        data-aos-duration="2000" className="text-center blog">
                        <div className="my-3 my-md-0">
                            <h1 className="blog-h1">Notre Histoire</h1>
                            {/* <h1 className="section-header text-uppercase my-4" style={{ borderBottom: '5px solid goldenrod', fontSize: '4rem'}}>Open air patio</h1> */}
                        </div>
                        {/* <h1 className="blog-h1">Our Story</h1> */}
                        <div className="mt-3 px-2 mt-md-3 px-md-5">
                            <p>Découvrez Le Sonarga</p>
                            <p>Restaurant sur place et à emporter.</p>
                            <p>Situé au coeur des Pyrénées dans la belle ville de Saint Gaudens. Un restaurant traditionnel indien tenu par des chefs extraordinaires d'origine indienne pour vous donner le goût spectaculaire de l'art culinaire indien.</p>
                        </div>
                        <NavLink to="/about">
                            <button className="animated-button victoria">Lire La Suite</button>
                        </NavLink>
                    </div>

                </Col>
                <Col md={6} className='p-0 d-none d-md-block'><img data-aos="zoom-in"
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="2000" className="w-100" src={blog1} alt="" /></Col>
                <Col md={6} className='p-0'><img data-aos="zoom-in"
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="2000" className="w-100" src={blog3} alt="" /></Col>
                <Col md={6} className="d-flex justify-content-center align-items-center p-0">
                    <div data-aos="zoom-in"
                        data-aos-easing="ease-out-cubic"
                        data-aos-duration="2000" className="text-center blog">
                        <div className="my-3 my-md-0">
                            <h1 className="blog-h1">Repas De Groupe</h1>
                            {/* <h1 className="section-header text-uppercase my-4" style={{ borderBottom: '5px solid goldenrod', fontSize: '4rem'}}>Open air patio</h1> */}
                        </div>
                        {/* <h1 className="blog-h1">Group Dining</h1> */}
                        <div className="mt-3 px-2 mt-md-3 px-md-5">
                            <p>Que vous organisiez une fête à la maison ou un événement d'affaires, vos invités passeront le meilleur moment tout en profitant de LE-SONARGAON.</p>
                            <p>"Laissez-nous faire tout le travail pendant que vous appréciez la compagnie de vos invités"</p>
                        </div>
                        <NavLink to="/contact">
                            <button className="animated-button victoria">Reserve Maintenant</button>
                        </NavLink>
                    </div>

                </Col>
            </Row>
        </div>
    );
};

export default Blogs;
